import { render, staticRenderFns } from "./BbchGridTemplate.vue?vue&type=template&id=330ca6b0&scoped=true"
import script from "./BbchGridTemplate.vue?vue&type=script&lang=js"
export * from "./BbchGridTemplate.vue?vue&type=script&lang=js"
import style0 from "./BbchGridTemplate.vue?vue&type=style&index=0&id=330ca6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ca6b0",
  null
  
)

export default component.exports